module.exports = __webpack_public_path__ + "static/media/gannon_irb.d94995aa.png";